var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4 text-sm border rounded-lg",class:_vm.alertClasses},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }